module.exports = require("D:\\project\\aman\\gatsby\\gatsby-browser.ts");